import { render, staticRenderFns } from "./modalContratarMenu.vue?vue&type=template&id=6d2298d0&"
import script from "./modalContratarMenu.vue?vue&type=script&lang=js&"
export * from "./modalContratarMenu.vue?vue&type=script&lang=js&"
import style0 from "./modalContratarMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modalContratarMenu.vue"
export default component.exports